/**
 * Created by dok on 13/12/2016.
 */

angular.module('tf.directives')

    .directive('cropbox', function() {


        return {
            restrict: 'E',
            template: '<div class="cropbox"></div>',
            replace: true,
            scope:{
                image: '=',
                options: '=',
                api: '='
            },
            link : function(scope,element,attr){

                var options = scope.options || {};

                var box,
                    boxContainer,
                    overlay,
                    n, s, w, e, ne, nw, se, sw,
                    tgl,bgl,lgl,rgl;

                var flippedX = false;
                var flippedY = false;
                var lastLimitedDX = 0;
                var lastLimitedDY = 0;

                var handleSize = 10;
                var outline = 1;
                var handleMargin = handleSize / 2;
                var parentWidth = Number(options.parentWidth);
                var parentHeight = Number(options.parentHeight);

                var aspectRatio = parentWidth / parentHeight;

                var CROP_SIZE_DELTA = 0.005;

                var operators = {
                    "+":function(a,b){return a+b;},
                    "-":function(a,b){return a-b;}
                };

                function limitX(value){
                    return Math.max(0, Math.min(value, scope.image.width));
                }
                function limitY(value){
                    return Math.max(0, Math.min(value, scope.image.height));
                }

                var boxData = {
                    x0 : options.crop.x0 !== undefined ? options.crop.x0 : 0.0,
                    y0 : options.crop.y0 !== undefined ? options.crop.y0 : 0.0,
                    x1 : options.crop.x1 !== undefined ? options.crop.x1 : 1.0,
                    y1 : options.crop.y1 !== undefined ? options.crop.y1 : 1.0,

                    getX0 : function(){ return boxData.x0 * scope.image.width; },
                    getY0 : function(){ return boxData.y0 * scope.image.height; },
                    getX1 : function(){ return boxData.x1 * scope.image.width; },
                    getY1 : function(){ return boxData.y1 * scope.image.height; },

                    setX0 : function(value){
                        boxData.x0 = options.crop.x0 = limitX(value) / scope.image.width;
                        var wasFlipped = flippedX;
                        flippedX = boxData.x0 > boxData.x1;
                        if(flippedX !== wasFlipped){
                            lastLimitedDX = 0;
                        }

                    },
                    setY0 : function(value){
                        boxData.y0 = options.crop.y0 = limitY(value) / scope.image.height;
                        var wasFlipped = flippedY;
                        flippedY = boxData.y0 > boxData.y1;
                        if(flippedY !== wasFlipped) {
                            lastLimitedDY = 0;
                        }
                    },
                    setX1 : function(value){
                        boxData.x1 = options.crop.x1 = limitX(value) / scope.image.width;
                        var wasFlipped = flippedX;
                        flippedX = boxData.x0 > boxData.x1;
                        if(flippedX !== wasFlipped){
                            lastLimitedDX = 0;
                        }
                    },
                    setY1 : function(value){
                        boxData.y1 = options.crop.y1 = limitY(value) / scope.image.height;
                        var wasFlipped = flippedY;
                        flippedY = boxData.y0 > boxData.y1;
                        if(flippedY !== wasFlipped) {
                            lastLimitedDY = 0;
                        }
                    },
                    isFlipped : function(){
                        return flippedX && flippedY;
                    },
                    isFlippedX : function(){
                        return flippedX;
                    },
                    isFlippedY : function(){
                        return flippedY;
                    },
                    getDX : function(){ return Math.abs(boxData.getX1() - boxData.getX0()); },
                    getDY : function(){ return Math.abs(boxData.getY1() - boxData.getY0()); },
                    getPoints : function(){return {x0 : boxData.x0, y0 : boxData.y0, x1 : boxData.x1, y1 : boxData.y1};},
                    getMiddleX : function(){
                        return Math.min(boxData.getX0(), boxData.getX1()) + (boxData.getDX() / 2);
                    },
                    getMiddleY : function(){
                        return Math.min(boxData.getY0(), boxData.getY1()) + (boxData.getDY() / 2);
                    }


                };


                //**************** Helpers ****************/

                function createHandle(dragFunc, cursor){
                    return boxContainer.append("rect")
                        .attr("height", handleSize)
                        .attr("width", handleSize)
                        .attr("fill", d3.rgb("#39f"))
                        .attr("cursor",cursor)
                        .call(dragFunc);
                }
                function createGridLine(){
                    return boxContainer.append("line")
                        .attr('stroke', 'white')
                        .style('stroke-opacity',0.3)
                        .style("stroke-dasharray", ("3, 3"));

                }
                function invertX() {
                    var tmpX = boxData.getX0();
                    boxData.setX0(boxData.getX1());
                    boxData.setX1(tmpX);
                }
                function invertY() {
                    var tmpY = boxData.getY0();
                    boxData.setY0(boxData.getY1());
                    boxData.setY1(tmpY);
                }
                function invert(){
                    if(boxData.getX0() > boxData.getX1()){
                        invertX();
                    }
                    if(boxData.getY0() > boxData.getY1()){
                        invertY();
                    }
                    update();
                }
                //*****************************************/

                //**************** Draw Functions ****************/

                function redraw() {
                    svg.attr({width: scope.image.width, height: scope.image.height});
                    update();
                }
                function drawOverlay(){
                    overlay = svg.append("g").append("path").attr("class", "cropbox-overlay").attr({
                        'fill-opacity' : 0.5,
                        'fill' : 'black',
                        'fill-rule' : "evenodd"
                    });
                }
                function drawBox(){
                    boxContainer = svg.append("g");
                    box = boxContainer
                        .append("rect")
                        .attr("class", "cropbox")
                        .attr("fill-opacity", 0)
                        .attr("cursor", "move")
                        .style("stroke", d3.rgb("#39f"))
                        .style("stroke-width", outline)
                        .call(d3.behavior.drag().on('drag', dragBox).on('dragend', dragEnd));
                }
                function drawGrid(){
                    tgl = createGridLine();
                    bgl = createGridLine();
                    lgl = createGridLine();
                    rgl = createGridLine();
                }

                function drawHandles(){
                    nw = createHandle(dragNW(), 'nw-resize');
                    ne = createHandle(dragNE(), 'ne-resize');
                    se = createHandle(dragSE(), 'se-resize');
                    sw = createHandle(dragSW(), 'sw-resize');
                    n = createHandle(dragN(), 'n-resize');
                    s = createHandle(dragS(), 's-resize');
                    e = createHandle(dragE(), 'e-resize');
                    w = createHandle(dragW(), 'w-resize');
                }

                function draw(){
                    drawOverlay();
                    drawBox();
                    drawHandles();
                    drawGrid();
                }

                //************************************************/

                //**************** Update Functions ****************/
                function updateOverlay(){
                    overlay.attr('d',
                        " M 0 0" +
                        " H " + scope.image.width +
                        " V " + scope.image.height +
                        " H " + 0 +
                        " V " + 0 +

                        " M " + boxData.getX0() + " " + boxData.getY0() +
                        " L " + boxData.getX0() + " " + boxData.getY1() +
                        " L " + boxData.getX1() + " " + boxData.getY1() +
                        " L " + boxData.getX1() + " " + boxData.getY0() +
                        " L " + boxData.getX0() + " " + boxData.getY0()
                    );
                }
                function updateBox(){
                    box.attr({
                        x: Math.min(boxData.getX0(), boxData.getX1()),
                        y: Math.min(boxData.getY0(), boxData.getY1()),
                        width: Math.abs(boxData.getX1() - boxData.getX0()),
                        height: Math.abs(boxData.getY1() - boxData.getY0())
                    });
                }
                function updateGrid(){
                    tgl
                        .attr("x1", boxData.getX0() + outline)
                        .attr("y1",boxData.getY0() + ((boxData.getY1() - boxData.getY0()) /3))
                        .attr("x2", boxData.getX1() - outline)
                        .attr("y2",boxData.getY0() + ((boxData.getY1() - boxData.getY0()) /3));

                    bgl
                        .attr("x1", boxData.getX0() + outline)
                        .attr("y1",boxData.getY0() + ((boxData.getY1() - boxData.getY0()) /3 * 2))
                        .attr("x2", boxData.getX1() - outline)
                        .attr("y2",boxData.getY0() + ((boxData.getY1() - boxData.getY0()) /3 * 2));

                    lgl
                        .attr("x1", boxData.getX0() + ((boxData.getX1() - boxData.getX0()) /3))
                        .attr("y1",boxData.getY0() + outline)
                        .attr("x2", boxData.getX0() + ((boxData.getX1() - boxData.getX0()) /3))
                        .attr("y2",boxData.getY1() - outline);

                    rgl
                        .attr("x1", boxData.getX0() + ((boxData.getX1() - boxData.getX0()) /3 * 2))
                        .attr("y1",boxData.getY0() + outline)
                        .attr("x2", boxData.getX0() + ((boxData.getX1() - boxData.getX0()) /3 * 2))
                        .attr("y2",boxData.getY1() - outline);
                }
                function updateHandles(){
                    nw
                        .attr('x', boxData.getX0() - handleMargin)
                        .attr('y', boxData.getY0() - handleMargin);
                    ne
                        .attr('x', boxData.getX1() - handleSize + handleMargin)
                        .attr('y',boxData.getY0() - handleMargin);
                    se
                        .attr('x', boxData.getX1() - handleSize + handleMargin)
                        .attr('y',boxData.getY1() - handleSize + handleMargin);
                    sw
                        .attr('x',boxData.getX0() - handleMargin)
                        .attr('y', boxData.getY1() - handleSize + handleMargin);
                    n
                        .attr('x', boxData.getX0() + ((boxData.getX1() - boxData.getX0() - handleSize) /2))
                        .attr('y', boxData.getY0() - handleMargin);
                    s
                        .attr('x',boxData.getX0() + ((boxData.getX1() - boxData.getX0() - handleSize) /2))
                        .attr('y', boxData.getY1() - handleSize + handleMargin);
                    e
                        .attr('x', boxData.getX1() - handleSize + handleMargin)
                        .attr('y', boxData.getY0() + ((boxData.getY1() - boxData.getY0() - handleSize) /2));
                    w
                        .attr('x', boxData.getX0() - handleMargin)
                        .attr('y', boxData.getY0() + ((boxData.getY1() - boxData.getY0() - handleSize) /2));
                }
                function update(){
                    updateOverlay();
                    updateBox();
                    updateGrid();
                    updateHandles();
                }

                //**************************************************/

                //**************** Behaviors ****************/

                function dragBox() {
                    var e = d3.event;

                    var w = Math.abs(boxData.getX1() - boxData.getX0());
                    var h = Math.abs(boxData.getY1() - boxData.getY0());
                    boxData.setX0(Math.max(0, Math.min(boxData.getX0() + e.dx, scope.image.width - w)));
                    boxData.setX1(Math.max(w, Math.min(boxData.getX1() + e.dx, scope.image.width)));

                    boxData.setY0(Math.max(0, Math.min(boxData.getY0() + e.dy, scope.image.height - h)));
                    boxData.setY1(Math.max(h, Math.min(boxData.getY1() + e.dy, scope.image.height)));

                    box.style('cursor', 'move');
                    update();
                }
                function dragEnd(){
                    invert();
                    flippedX = false;
                    flippedY = false;
                    lastLimitedDX = 0;
                    lastLimitedDY = 0;
                    scope.$apply();
                }

                function isLimitReached(){
                    return isNLimitReached() || isSLimitReached() || isWLimitReached() || isELimitReached();
                }

                function isNLimitReached(){
                    return boxData.getY0() <= 0 ||
                        boxData.getY1() <= 0;
                }
                function isSLimitReached(){
                    return boxData.getY0() >= scope.image.height ||
                        boxData.getY1() >= scope.image.height;
                }
                function isELimitReached(){
                    return boxData.getX0() >= scope.image.width ||
                        boxData.getX1() >= scope.image.width;
                }
                function isWLimitReached(){
                    return boxData.getX0() <= 0 ||
                        boxData.getX1() <= 0;
                }

                function setToLimitedXDimensions(){
                    if (isWLimitReached()) {
                        boxData.setX1(boxData.getX0() + (lastLimitedDY * aspectRatio));
                    } else if (isELimitReached()) {
                        boxData.setX0(boxData.getX1() - (lastLimitedDY * aspectRatio));
                    }
                }

                function setToLimitedYDimensions(){
                    if (isNLimitReached()) {
                        boxData.setY1(boxData.getY0() + (lastLimitedDX / aspectRatio));
                    } else if (isSLimitReached()) {
                        boxData.setY0(boxData.getY1() - (lastLimitedDX / aspectRatio));
                    }
                }

                function dragNW(){
                    return d3.behavior.drag().on('drag', function(){
                        var e = d3.event;
                        if(options.lockAspect && aspectRatio) {
                            if(!isLimitReached() ||
                                    (!boxData.isFlipped() && (e.dy > 0 || ((isSLimitReached() || isELimitReached()) && !isWLimitReached() && !isNLimitReached()))) ||
                                    (boxData.isFlipped() && e.dy < 0)){
                                boxData.setY0(boxData.getY0() + e.dy);
                                if(boxData.getY0() < boxData.getY1()) {
                                    boxData.setX0(boxData.getX1() - (boxData.getDY() * aspectRatio));
                                }else{
                                    boxData.setX0(boxData.getX1() + (boxData.getDY() * aspectRatio));
                                }
                            }else{
                                boxData.setY0(operators[boxData.isFlippedY() ? "+" : "-"](boxData.getY1(), (boxData.getDX() / aspectRatio)));
                            }
                        }else{
                            boxData.setX0(boxData.getX0() + e.dx);
                            boxData.setY0(boxData.getY0() + e.dy);
                        }
                        update();
                    })
                        .on('dragend', dragEnd);
                }

                function dragNE(){
                    return d3.behavior.drag().on('drag', function(){
                        var e = d3.event;
                        if(options.lockAspect && aspectRatio) {
                            if(!isLimitReached() ||
                                    (!boxData.isFlipped() && (e.dy > 0 || ((isSLimitReached() || isWLimitReached()) && !isELimitReached() && !isNLimitReached()))) ||
                                (boxData.isFlipped() && e.dy < 0)){
                                boxData.setY0(boxData.getY0() + e.dy);
                                if(boxData.getY0() < boxData.getY1()){
                                    boxData.setX1(boxData.getX0() + (boxData.getDY() * aspectRatio));
                                }else{
                                    boxData.setX1(boxData.getX0() - (boxData.getDY() * aspectRatio));
                                }
                            }else{
                                boxData.setY0(operators[boxData.isFlippedY() ? "+" : "-"](boxData.getY1(), (boxData.getDX() / aspectRatio)));
                            }
                        }else{
                            boxData.setX1(boxData.getX1() + e.dx);
                            boxData.setY0(boxData.getY0() + e.dy);
                        }

                        update();
                    }).on('dragend', dragEnd);
                }

                function dragSW(){
                    return d3.behavior.drag().on('drag', function(){
                        var e = d3.event;
                        if(options.lockAspect && aspectRatio) {
                            if(!isLimitReached() ||
                                    (!boxData.isFlipped() && (e.dx > 0 || ((isNLimitReached() || isELimitReached()) && !isWLimitReached() && !isSLimitReached()))) ||
                                    (boxData.isFlipped() && e.dx < 0) ){
                                boxData.setX0(boxData.getX0() + e.dx);
                                if(boxData.getX0() < boxData.getX1()) {
                                    boxData.setY1(boxData.getY0() + (boxData.getDX() / aspectRatio));
                                }else{
                                    boxData.setY1(boxData.getY0() - (boxData.getDX() / aspectRatio));
                                }
                            }else{
                                boxData.setX0(operators[boxData.isFlippedX() ? "+" : "-"](boxData.getX1(), (boxData.getDY() * aspectRatio)));
                            }
                        }else{
                            boxData.setX0(boxData.getX0() + e.dx);
                            boxData.setY1(boxData.getY1() + e.dy);
                        }

                        update();
                    }).on('dragend', dragEnd);
                }

                function dragSE(){
                    return d3.behavior.drag().on('drag', function(){
                        var e = d3.event;
                        if(options.lockAspect && aspectRatio) {

                            if(!isLimitReached() ||
                                    (!boxData.isFlipped() && (e.dx < 0 || ((isNLimitReached() || isWLimitReached()) && !isELimitReached() && !isSLimitReached()))) ||
                                    (boxData.isFlipped() && e.dx > 0)){
                                boxData.setX1(boxData.getX1() + e.dx);
                                if(boxData.getX0() < boxData.getX1()) {
                                    boxData.setY1(boxData.getY0() + (boxData.getDX() / aspectRatio));
                                }else {
                                    boxData.setY1(boxData.getY0() - (boxData.getDX() / aspectRatio));
                                }
                            }else{
                                boxData.setX1(operators[!boxData.isFlippedX() ? "+" : "-"](boxData.getX0(), (boxData.getDY() * aspectRatio)));
                            }
                        }else{
                            boxData.setX1(boxData.getX1() + e.dx);
                            boxData.setY1(boxData.getY1() + e.dy);
                        }

                        update();
                    }).on('dragend', dragEnd);
                }

                function dragN(){
                    return d3.behavior.drag().on('drag', function(){
                        var e = d3.event;

                        if(options.lockAspect && aspectRatio) {
                            if (!isLimitReached() ||
                                    (!boxData.isFlippedY() && (e.dy > 0 || (isSLimitReached() && !isELimitReached() && !isWLimitReached() && !isNLimitReached()))) ||
                                    (boxData.isFlippedY() && e.dy < 0)) {
                                boxData.setY0(boxData.getY0() + e.dy);
                                var middleX = boxData.getMiddleX();
                                boxData.setX0(middleX - (boxData.getDY() * aspectRatio) / 2);
                                boxData.setX1(middleX + (boxData.getDY() * aspectRatio) / 2);
                            }else{
                                if(lastLimitedDY === 0) {
                                    lastLimitedDY = boxData.getDY();
                                }
                                boxData.setY0(operators[boxData.isFlippedY() ? "+" : "-"](boxData.getY1(), (boxData.getDX() / aspectRatio)));
                                setToLimitedXDimensions();
                            }
                        } else {
                            boxData.setY0(boxData.getY0() + e.dy);
                        }

                        update();
                    }).on('dragend', dragEnd);
                }

                function dragS(){
                    return d3.behavior.drag().on('drag', function(){
                        var e = d3.event;
                        if(options.lockAspect && aspectRatio){
                            if(!isLimitReached() ||
                                    (!boxData.isFlippedY() && (e.dy < 0 || (isNLimitReached() && !isELimitReached() && !isWLimitReached() && !isSLimitReached()))) ||
                                    (boxData.isFlippedY() && e.dy > 0)) {
                                boxData.setY1(boxData.getY1() + e.dy);
                                var middleX = boxData.getMiddleX();
                                boxData.setX0(middleX - (boxData.getDY() * aspectRatio) / 2);
                                boxData.setX1(middleX + (boxData.getDY() * aspectRatio) / 2);
                            }else{
                                if(lastLimitedDY === 0) {
                                    lastLimitedDY = boxData.getDY();
                                }
                                boxData.setY1(operators[!boxData.isFlippedY() ? "+" : "-"](boxData.getY0(), (boxData.getDX() / aspectRatio)));
                                setToLimitedXDimensions();
                            }
                        } else {
                            boxData.setY1(boxData.getY1() + e.dy);
                        }
                        update();
                    }).on('dragend', dragEnd);
                }

                function dragE(){
                    return d3.behavior.drag().on('drag', function(){
                        var e = d3.event;
                        if(options.lockAspect && aspectRatio) {

                            if(!isLimitReached() ||
                                    (!boxData.isFlippedX() && (e.dx < 0 || (isWLimitReached() && !isELimitReached() && !isSLimitReached() && !isNLimitReached()))) ||
                                    (boxData.isFlippedX() && e.dx > 0)){
                                boxData.setX1(boxData.getX1() + e.dx);
                                var middleY = boxData.getMiddleY();
                                boxData.setY0(middleY - ((boxData.getDX() / aspectRatio) / 2));
                                boxData.setY1(middleY + ((boxData.getDX() / aspectRatio) / 2));
                            }else{
                                if(lastLimitedDX === 0) {
                                    lastLimitedDX = boxData.getDX();
                                }
                                boxData.setX1(operators[!boxData.isFlippedX() ? "+" : "-"](boxData.getX0(), (boxData.getDY() * aspectRatio)));
                                setToLimitedYDimensions();
                            }
                        } else{
                            boxData.setX1(boxData.getX1() + e.dx);
                        }

                        update();
                    }).on('dragend', dragEnd);
                }

                function dragW(){
                    return d3.behavior.drag().on('drag', function(){
                        var e = d3.event;
                        if(options.lockAspect && aspectRatio) {
                            if(!isLimitReached() ||
                                    (!boxData.isFlippedX() && (e.dx > 0 || (isELimitReached() && !isSLimitReached() && !isWLimitReached() && !isNLimitReached()))) ||
                                    (boxData.isFlippedX() && e.dx < 0)){
                                boxData.setX0(boxData.getX0() + e.dx);
                                var middleY = boxData.getMiddleY();
                                boxData.setY0(middleY - ((boxData.getDX() / aspectRatio) / 2));
                                boxData.setY1(middleY + ((boxData.getDX() / aspectRatio) / 2));
                            }else{
                                if(lastLimitedDX === 0) {
                                    lastLimitedDX = boxData.getDX();
                                }
                                boxData.setX0(operators[boxData.isFlippedX() ? "+" : "-"](boxData.getX1(), (boxData.getDY() * aspectRatio)));
                                setToLimitedYDimensions();
                            }
                        }else{
                            boxData.setX0(boxData.getX0() + e.dx);
                        }
                        update();
                    }).on('dragend', dragEnd);
                }

                //*******************************************/

                //**************** Init ****************/

                var svg = d3.select(element[0]).append('svg').attr({width: scope.image.width, height: scope.image.height});
                draw();
                update();
                window.addEventListener("resize", redraw);
                //**************************************/

                scope.api.resetCropLockAspect = function(center){
                    var currentBoxAspect = boxData.getDX() / boxData.getDY();
                    if(Math.abs(aspectRatio - currentBoxAspect) >  CROP_SIZE_DELTA){
                        if(center){
                            resetToMaxSize();
                        } else {
                            resetToClosestSize();
                        }

                        update();
                    }
                };

                function resetToClosestSize(){
                    if(boxData.getDX() / boxData.getDY() < aspectRatio) {
                        boxData.setY1(boxData.getDY() - (boxData.getDY() - (boxData.getY0() + (boxData.getDX() / aspectRatio))));
                    }else{
                        boxData.setX1(boxData.getDX() - (boxData.getDX() - (boxData.getX0() + (boxData.getDY() * aspectRatio))));
                    }
                }
                function resetToMaxSize() {
                    if(parentWidth < parentHeight || (scope.image.width / scope.image.height) > aspectRatio){
                        boxData.setX0(((scope.image.width) - (scope.image.height * aspectRatio)) / 2);
                        boxData.setY0(0);

                        boxData.setY1(scope.image.height);
                        boxData.setX1(scope.image.width - ((scope.image.width) - (scope.image.height * aspectRatio)) / 2);
                    } else {
                        boxData.setX0(0);
                        boxData.setY0(((scope.image.height) - (scope.image.width / aspectRatio)) / 2);

                        boxData.setY1(scope.image.height - (((scope.image.height) - (scope.image.width / aspectRatio)) / 2));
                        boxData.setX1(scope.image.width);
                    }
                }
            }
        };

    });